import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        background: "#f4f8ff",
        color: "#1e1e1e",
        borderRadius: "12px",
        maxWidth: "900px",
        margin: "20px auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <h1
        style={{
          color: "#1a73e8",
          marginBottom: "15px",
          textAlign: "center",
        }}
      >
        Privacy Policy
      </h1>

      <p>
        Welcome to <strong>Toshni Jewellers</strong> (https://toshnijewellers.com). We
        respect your privacy and are committed to protecting your personal
        information. This Privacy Policy explains how we collect, use, disclose
        and safeguard your data when you interact with our website or services.
      </p>

      <h3 style={{ color: "#d63384" }}>1. Information We Collect</h3>
      <ul style={{ paddingLeft: "20px" }}>
        <li>Personal details: name, email, phone number, shipping & billing address</li>
        <li>Account information if you create a profile on our website</li>
        <li>Order & purchase history</li>
        <li>Payment information processed securely through trusted payment gateways</li>
        <li>Device, browser and IP information for security & analytics</li>
        <li>Cookies & tracking data to enhance user experience</li>
      </ul>

      <h3 style={{ color: "#d63384" }}>2. How We Use Your Information</h3>
      <ul style={{ paddingLeft: "20px" }}>
        <li>To process and fulfill orders (including delivery & certification)</li>
        <li>To provide customer support and respond to inquiries</li>
        <li>To send order confirmations, updates & promotional offers (only with consent)</li>
        <li>To prevent fraud and ensure website security</li>
        <li>To improve product offerings and user interaction</li>
      </ul>

      <h3 style={{ color: "#d63384" }}>3. Data Protection & Security</h3>
      <p>
        We use industry-standard encryption and safety measures to protect your
        data. All payment details are processed securely through PCI-DSS compliant
        payment gateways. We do <strong>not</strong> store your complete card or
        banking information.
      </p>

      <h3 style={{ color: "#d63384" }}>4. Sharing of Information</h3>
      <p>
        We do <strong>not</strong> sell or trade your personal data. Information may be
        shared only with:
      </p>
      <ul style={{ paddingLeft: "20px" }}>
        <li>Trusted payment processors (Razorpay, PayU, Cashfree, etc.)</li>
        <li>Shipping and courier partners for order delivery</li>
        <li>Government or legal authorities as required under Indian law</li>
      </ul>

      <h3 style={{ color: "#d63384" }}>5. Cookies</h3>
      <p>
        We use cookies to improve browsing experience, analyze website traffic,
        store preferences, and show personalized jewellery recommendations.
      </p>

      <h3 style={{ color: "#d63384" }}>6. Your Rights</h3>
      <ul style={{ paddingLeft: "20px" }}>
        <li>Request access, correction or deletion of your stored data</li>
        <li>Unsubscribe from marketing communications anytime</li>
        <li>Disable cookies through your browser settings</li>
      </ul>

      <h3 style={{ color: "#d63384" }}>7. Children’s Privacy</h3>
      <p>Our website is not intended for children under 13 years of age.</p>

      <h3 style={{ color: "#d63384" }}>8. Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date.
      </p>

      <h3 style={{ color: "#d63384" }}>9. Contact Us</h3>
      <p>If you have any questions or concerns, you can contact us at:</p>

      <div
        style={{
          background: "#e3f2fd",
          padding: "15px",
          borderRadius: "8px",
          border: "1px solid #bbdefb",
        }}
      >
        <p>
          Phone: <a href="tel:+919352212342">+91 9352212342</a>
          <br />
          Email: <a href="mailto:info@toshnijewellers.com">info@toshnijewellers.com</a>
          <br />
          Address: Rd Number 1,
          <br />
          <strong>Behind Murlipura Thana</strong>, Pravasi Nagar,
          <br />
          Murlipura, Jaipur, Rajasthan – 302039, India.
        </p>
      </div>

      <p style={{ marginTop: "20px", fontStyle: "italic" }}>
        Last Updated: <strong>{new Date().toLocaleDateString()}</strong>
      </p>
    </div>
  );
}
